export enum RedditEvents {
	Purchase = "Purchase",
	Lead = "Lead",
	SignUp = "SignUp",
}

export interface RedditEventType {
	tracking_type: string;
	custom_event_name?: string;
}

export interface RedditEventUser {
	ip_address?: string;
	email?: string;
	external_id?: string;
	click_id?: string;
}

export interface RedditEvent {
	event_at: string;
	event_type: RedditEventType;
	click_id?: string;
	user?: RedditEventUser;
	event_metadata?: RedditEventMetadata;
}

export interface RedditEventMetadata {
	currency: string;
	value_decimal?: number;
	conversion_id?: string;
}

export interface RedditPayload {
	test_mode: boolean;
	events: RedditEvent[];
}
